import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import _ from 'lodash'
import PrivateRoutes from './routing/PrivateRoutes'
import ProtectedRoute from './routing/ProtectedRoute'
import routes from './routing/routes.js'

// Legacy styles to be removed
import '../assets/styles/primereact/index.scss'
import '../assets/styles/common.scss'
import '../assets/styles/width.scss'

// New Mantine styles
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/dropzone/styles.css'
import '../theme/theme.hacks.css'

const App = () => {
  const auth = useSelector((state) => state.auth)

  return (
    <BrowserRouter>
      <Routes>
        {/* Routes Public */}
        {routes.public.map(({ path, element, name }) => (
          <Route exact key={name} path={path} element={element} />
        ))}
        {/* Routes Private */}
        <Route
          path="/*"
          element={
            <ProtectedRoute isAllowed={!_.isEmpty(auth)}>
              <PrivateRoutes />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
